// eslint-disable-next-line import/no-extraneous-dependencies
import Swiper from 'swiper/bundle';

// MV
if (document.querySelector('[data-role="course-contents-mv-swiper"]') !== null) {
  // eslint-disable-next-line no-new
  let courseContentsMvSwiper = new Swiper('[data-role="course-contents-mv-swiper"]', {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    centerInsufficientSlides: true,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1500,
    pagination: {
      el: "[data-role='course-contents-mv-swiper-pagination']",
      clickable: true,
    },
  });
}

// 日付
const courseDayNav = document.querySelector('.course-day-nav');
if (courseDayNav !== null) {

  let courseDayDefaultTemplateId;
  const courseDaySwitchBtns = courseDayNav.querySelectorAll('.course-day-nav__btn');
  const courseDayShowArea = document.getElementById('course-day-block');
  courseDaySwitchBtns.forEach((courseDayBtn) => {
    if (courseDayBtn.classList.contains('is-active')) {
      courseDayDefaultTemplateId = courseDayBtn.getAttribute('data-template');
    }
  });

  const courseDayDefaultTemplate = document.getElementById(courseDayDefaultTemplateId);
  const courseDayDefaultTemplateClone = courseDayDefaultTemplate.content.cloneNode(true);
  
  // 初期状態の設定
  courseDayShowArea.innerHTML = '';
  const courseDayInitialElement = document.createElement('div');
  courseDayInitialElement.appendChild(courseDayDefaultTemplateClone);
  courseDayShowArea.appendChild(courseDayInitialElement);

  // swiper初期関数
  const courseDayInitializeSwipers = (container) => {
    const courseDaySwiperContainers = container.querySelectorAll('[data-role="course-day-spot-recommendations-swiper"]');
    courseDaySwiperContainers.forEach((swiperContainer) => {
      new Swiper(swiperContainer.querySelector('.swiper'), {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 16,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 750,
        navigation: {
          nextEl: swiperContainer.querySelector('[data-role="course-day-spot-recommendations-swiper-nav-next"]'),
          prevEl: swiperContainer.querySelector('[data-role="course-day-spot-recommendations-swiper-nav-prev"]'),
        },
      });
    });
  };

  // 初期状態の Swiper を初期化
  courseDayInitializeSwipers(courseDayInitialElement);

  // 要素切り替え
  const courseDaySwitchArea = document.querySelector('.course-day-nav');
  courseDaySwitchArea.addEventListener('click', (e) => {
    const courseDaySwitch = e.target;
    if (courseDaySwitch.hasAttribute('data-template')) {
      // 新しいテンプレートを表示する場合
      const courseDayActiveTemplate = courseDaySwitch.getAttribute('data-template');
      const courseDayShowTemplate = document.getElementById(courseDayActiveTemplate);
      const courseDayShowTemplateClone = courseDayShowTemplate.content.cloneNode(true);

      // ボタン切り替え
      courseDaySwitchBtns.forEach((btn) => {
        if (btn === courseDaySwitch) {
          btn.classList.add('is-active');
          btn.ariaSelected = true;
        } else {
          btn.classList.remove('is-active');
          btn.ariaSelected = false;
        }
      });

      // 中身切り替え
      courseDayShowArea.innerHTML = '';
      const courseDayNewElement = document.createElement('div');
      courseDayNewElement.appendChild(courseDayShowTemplateClone);
      courseDayShowArea.appendChild(courseDayNewElement);

      // 新しい要素内の Swiper を初期化
      courseDayInitializeSwipers(courseDayNewElement);
    }
  });
}
